import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'company'

const CompanyModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default CompanyModule



// WEBPACK FOOTER //
// ./src/store/module/company/index.js